/* eslint-disable unicorn/prefer-spread */
export class DOMUtils {
  private readonly FOCUSABLE_ELEMENTS =
    'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]';

  public getAllFocusableElements(element: HTMLElement | ShadowRoot) {
    return this.traverseDOMTree(element);
  }

  public getActiveElement() {
    let activeElement = document.activeElement;
    activeElement = this.getActiveElementFromShadowRoot(activeElement);

    return activeElement;
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity

  private getActiveElementFromShadowRoot(element: Element) {
    let result = element;

    if (element.shadowRoot) {
      result = this.getActiveElementFromShadowRoot(
        element.shadowRoot.activeElement
      );
    }

    return result;
  }

  private isSlottedElement(element: Element): boolean {
    return element.tagName === 'SLOT';
  }

  private isShadowRootElement(element: Element): boolean {
    return !!element.shadowRoot;
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  private traverseDOMTree(
    element: Element | ShadowRoot,
    focusableElements = []
  ) {
    if (!element.querySelectorAll) {
      return;
    }

    let focusable = [
      ...focusableElements,
      ...Array.from(element.querySelectorAll(this.FOCUSABLE_ELEMENTS)),
    ];

    if (!focusable || focusable.length === 0) {
      const children = Array.from(element.querySelectorAll('*'));

      for (const child of children) {
        if (this.isSlottedElement(child)) {
          const slottedElement = child as HTMLSlotElement;
          const assignedNodes = slottedElement.assignedNodes();

          if (assignedNodes && assignedNodes.length > 0) {
            for (const node of assignedNodes) {
              const nodeElement = node as Element;
              let nodeToTraverse: Element | ShadowRoot = nodeElement;
              if (nodeElement.shadowRoot) {
                nodeToTraverse = nodeElement.shadowRoot as ShadowRoot;
              }

              const slotNodesResult = this.traverseDOMTree(
                nodeToTraverse,
                focusableElements
              );
              if (slotNodesResult && slotNodesResult.length > 0) {
                focusable = [...focusable, ...slotNodesResult];
              }
            }
          }
        } else if (this.isShadowRootElement(child)) {
          const shadowRootResult = this.traverseDOMTree(
            child.shadowRoot,
            focusableElements
          );
          focusable = [...focusable, ...shadowRootResult];
        }
      }
    }

    return focusable;
  }
}
